const validateAssignment = ({ title }) => (title ? {} : { title: true });

export default validateAssignment;
